module.exports = __webpack_public_path__ + "assets/share 2-0372223f9003a297ff339882355e4878.svg";